import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Fieldset,
  Legend,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
  ButtonGroup,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import Select from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect, withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";
import IndexBloc from "../Blocs/IndexBloc";

class ReturnModal extends Component {
  indexBloc = new IndexBloc();
  timer;
  source;
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: null,
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.props.uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  submitData = async () => {
    const dataForm = generateFormData(
      this.state.dataForm,
      "employee_transfer_detail_return_document"
    );
    await this.indexBloc.fetchUpdateReturn(dataForm);
  };

  componentDidMount() {
    this.indexBloc.updateReturnChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.props.handleReload();
              }
            );
          } else {
            this.setState({
              loading: false,
              failed: true,
            });
          }
          this.props.toggle();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    return (
      <Fragment>
        <Modal
          isOpen={this.props.modal}
          size="lg"
          centered={true}
          toggle={this.props.toggle}
        >
          <ModalHeader toggle={this.props.toggle}>
            Edit Waktu Kepulangan
          </ModalHeader>
          <ModalBody>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Tanggal Kepulangan <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <AvField
                    placeholder="Tanggal Kepulangan.."
                    name="employee_transfer_detail_return_date"
                    type="date"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Bukti Kepulangan <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <FileInput
                    placeholder="Bukti Kepulangan"
                    name="employee_transfer_detail_return_document"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              {this.props.doc_return ? (
                <Row className="mb-3">
                  <Col md="3"></Col>
                  <Col md="3">
                    <a
                      href={this.props.doc_return?.documents_path}
                      target="_blank"
                      className="btn btn-success btn-sm"
                    >
                      <i className="uil-download-alt"></i> Download{" "}
                    </a>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              <ModalFooter>
                <Button color="secondary" onClick={this.props.toggle}>
                  Cancel
                </Button>{" "}
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </AvForm>
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default ReturnModal;
